import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';
import { addPrefix, prefixes, regular } from './common';
import { commonContainerSkinParamsUDP } from './containerSkinParams';
import { cssPropertyToDefaultValueMap } from '@wix/editor-elements-panel/dist/esm/constants';
import { DropdownAnchor, MenuAlignment } from '../constants';

export const ownDropdownSkinParamsUDP: SkinDefinition = {};
export const dropdownSkinParamsUDP: SkinDefinition = {
  ...commonContainerSkinParamsUDP,
  ...ownDropdownSkinParamsUDP,
};
export const prefixedDropdownSkinParamsUDP: SkinDefinition = addPrefix(
  dropdownSkinParamsUDP,
  prefixes.dropdown,
);

export const dropdownSkinParamsLayoutPanel: SkinDefinition = {
  anchor: {
    type: 'CSSString',
    state: regular,
    defaultValue: DropdownAnchor.menuItem,
  },
  align: {
    type: 'CSSString',
    state: regular,
    defaultValue: MenuAlignment.Start,
  },
  'horizontal-margin': {
    type: 'SIZE',
    state: regular,
    defaultValue: cssPropertyToDefaultValueMap['margin-left'],
  },
  'space-above': {
    type: 'SIZE',
    state: regular,
    defaultValue: cssPropertyToDefaultValueMap['margin-top'],
  },
};

export const prefixedDropdownSkinParamsLayoutPanel = addPrefix(
  dropdownSkinParamsLayoutPanel,
  prefixes.dropdown,
);

export const dropdownSkinParams: SkinDefinition = {
  ...dropdownSkinParamsUDP,
  ...dropdownSkinParamsLayoutPanel,
};

export const prefixedDropdownSkinParams: SkinDefinition = {
  ...prefixedDropdownSkinParamsUDP,
  ...prefixedDropdownSkinParamsLayoutPanel,
};
